import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function AboutUs() {
  return (
    <section
      className="relative bg-cover bg-center py-20 px-4"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?q=80&w=1613&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
      }}
    >
      <div className="absolute inset-0 bg-[#fef8f5] opacity-90" />

      <div className="relative max-w-4xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f] mb-6"
        >
          Thoughtfully crafted for your skin, and the planet.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="text-lg text-[#7a6e5f] opacity-80 mb-8"
        >
          At SuprSkin, we believe in more than just skincare. Our mission is to honour each skin type’s story — using clean, natural ingredients and sustainable practices that make you and the Earth feel good.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <Link
            to="/about"
            className="inline-block bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6d7d6d] transition-colors"
          >
            Learn More About Us
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
